"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendRequestQuotePurchaseNotification = exports.sendRequestRemoteToolsNotification = exports.sendRequestTrialNotification = exports.sendRequestSKUNotification = exports.sendRequestAdditionalSeatsNotification = exports.sendRequestAccessNotification = void 0;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var sendRequestAccessNotification = function sendRequestAccessNotification(merchandiseId) {
  return _apiClient.default.post('monetization-service/v2/request/access-owned', {
    data: {
      merchandiseId: merchandiseId
    }
  });
};

exports.sendRequestAccessNotification = sendRequestAccessNotification;

var sendRequestAdditionalSeatsNotification = function sendRequestAdditionalSeatsNotification(merchandiseId) {
  return _apiClient.default.post('monetization-service/v2/request/additional-seats', {
    data: {
      merchandiseId: merchandiseId
    }
  });
};

exports.sendRequestAdditionalSeatsNotification = sendRequestAdditionalSeatsNotification;

var sendRequestSKUNotification = function sendRequestSKUNotification(merchandiseId) {
  return _apiClient.default.post('monetization-service/v2/request/sku', {
    data: {
      merchandiseId: merchandiseId
    }
  });
};

exports.sendRequestSKUNotification = sendRequestSKUNotification;

var sendRequestTrialNotification = function sendRequestTrialNotification(merchandiseId) {
  return _apiClient.default.post('monetization-service/v2/request/trial', {
    data: {
      merchandiseId: merchandiseId
    }
  });
};

exports.sendRequestTrialNotification = sendRequestTrialNotification;

var sendRequestRemoteToolsNotification = function sendRequestRemoteToolsNotification() {
  return _apiClient.default.post('/monetization-service/v2/request/free-remote-sales-tools');
};

exports.sendRequestRemoteToolsNotification = sendRequestRemoteToolsNotification;

var sendRequestQuotePurchaseNotification = function sendRequestQuotePurchaseNotification(hub) {
  return _apiClient.default.post('monetization-service/v2/request/quote-purchase', {
    data: {
      hub: hub
    }
  });
};

exports.sendRequestQuotePurchaseNotification = sendRequestQuotePurchaseNotification;